import { useTranslation } from "react-i18next";
import LoginPasswordForm from "features/login/LoginPasswordForm";
import Section from "components/layout/section";
import LoginGoogleForm from "features/login/LoginGoogleForm";
import SectionHeader from "components/layout/sectionHeader";
import SectionHeaderTitle from "components/layout/sectionHeaderTitle";
import PageTitle from "features/navigation/pageTitle";
import Button from "@/components/inputs/button";
import { ReactComponent as SignUpIcon } from 'assets/icons/group_add.svg'
import Hint from "@/components/text/Hint"
import LegalLinks from "@/components/legal/LegalLinks";
import { MainSheetFooter } from "@/components/layout/layoutChrome";

const LoginPage = () => {

    const { t } = useTranslation()

    return (
        <>
            <PageTitle title={t('titleLogin')} />
            <MainSheetFooter>
                <LegalLinks className="text-sm text-gray-600" />
            </MainSheetFooter>
            <Section>
                <LoginPasswordForm />
                <Section design="centered-x">
                    <SectionHeader>
                        <SectionHeaderTitle design="divider">
                            <h3>{t('titleOtherLoginMethods')}</h3>
                        </SectionHeaderTitle>
                    </SectionHeader>
                    <Hint className="small text-center">{t('descriptionOtherLoginMethods')}</Hint>
                    <LoginGoogleForm />
                    <SectionHeader>
                        <SectionHeaderTitle design="divider">
                            <h3>{t('titleDontHaveAccount')}</h3>
                        </SectionHeaderTitle>
                    </SectionHeader>
                    <Button wideOnMobile to="/sign-up" design="white"><SignUpIcon /><span>{t('buttonSignUpForFree')}</span></Button>
                </Section>
            </Section>
        </>
    );
}

export default LoginPage
